const ready: Partial<Record<string, boolean>> = {};

export const loadScript = async <R>(src: string, onLoad: () => Promise<R>) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<R>(async (resolve) => {
    {
      // eslint-disable-next-line unicorn/prefer-query-selector
      const script = document.getElementById(src);

      if (script) {
        if (ready[src]) {
          resolve(await onLoad());
        } else {
          script.addEventListener('load', async () => {
            resolve(await onLoad());
          });
        }

        return;
      }
    }

    {
      const script = document.createElement('script');
      script.src = src;
      script.id = src;
      script.type = 'text/javascript';
      script.async = true;
      script.addEventListener('load', async () => {
        ready[src] = true;
        resolve(await onLoad());
      });

      document.head.append(script);
    }
  });
};
